import type { FormDefinition } from '@/core/templates/types'

export default {
  title: 'Checkliste Erstgespräch',
  sections: {
    Maßnahme: {
      fields: [{ id: 'Maßnahme.Datum des Gesprächs', control: 'date' }],
    },
    Teilnehmer: {
      fields: [
        { id: 'Teilnehmer.Nachname', control: 'text-or-date' },
        { id: 'Teilnehmer.Vorname', control: 'text-or-date' },
        { id: 'Teilnehmer.E-Mail', control: 'text-or-date' },
      ],
    },
    Voraussetzungen: {
      fields: [
        {
          id: 'Voraussetzungen.Deutschsprachkenntnisse A2/B1',
          control: 'select',
          options: ['erfüllt', 'Nachweis notwendig', 'Nachweis vorhanden'],
        },
        {
          id: 'Voraussetzungen.Online-Beratungsgespräch durchführen',
          control: 'select',
          options: ['erfüllt', 'Nachweis notwendig', 'Nachweis vorhanden'],
        },
        {
          id: 'Voraussetzungen.Technische Ausstattung',
          control: 'select',
          options: ['erfüllt', 'Nachweis notwendig', 'Nachweis vorhanden'],
        },
      ],
    },
    Gesprächsführer: {
      fields: [
        { id: 'Gesprächsführer.Name, Vorname', control: 'text-or-date' },
        { id: 'Gesprächsführer.Persönlicher Eindruck', control: 'text', dictation: true },
      ],
    },
    Entscheidung: {
      fields: [
        { id: 'Entscheidung.Integrationswahrscheinlichkeit', control: 'select', options: ['gering', 'mittel', 'hoch'] },
        { id: 'Entscheidung.Eignung', control: 'select', options: ['geeignet', 'nicht geeignet'] },
        { id: 'Entscheidung.Bemerkungen', control: 'text', dictation: true },
      ],
    },
  },
} satisfies FormDefinition
